module.exports = __webpack_public_path__ + "img/zhuanli3.dd81a78c.png";